export default "__VITE_ASSET__BHm2xuAK__"